const e = [
  "clearance",
  "featured",
  "free-gift",
  "new",
  "sale",
  "special-offer",
  "soldout"
];
export {
  e as AllBadgeVariants
};
